'use client'

import { PropsWithChildren } from 'react'
import { CookiesProvider } from 'react-cookie'

/**
 * Provides the `react-cookie` context required by `useCookies` (used by the
 * i18n client hook in `src/i18n/client.ts`). Wraps the whole app so both the
 * `I18nWarmer` and every page can read/write the locale cookie.
 */
export function AppCookiesProvider({ children }: PropsWithChildren) {
  return <CookiesProvider>{children}</CookiesProvider>
}
